import React from "react";
import Label, {LabelData} from "./label";

/**
 *
 */
type Data = {
    labels : LabelData[]
};

/**
 *
 * @param tags
 * @constructor
 */
export default function LabelList ({ labels } : Data)  {
    // render
    return (
        <>
            <div className="d-flex flex-row flex-wrap">
                {labels.map((label, index) =>
                    <Label key={'label-' + index} label={label} />
                )}
            </div>
        </>
    );
}